var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPagoEnEfectivo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.54 38.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3cc676;}.cls-2{fill:#0aa06e;}.cls-3{fill:#078457;}.cls-4{fill:#fff6e1;}.cls-5{fill:#ffeebd;}.cls-6{fill:#ffc114;}.cls-7{fill:#ff8a15;}.cls-8{fill:#d18307;}.cls-9{fill:#f2b233;}.cls-10{fill:#dd981d;}.cls-11{fill:#f9db7a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 18otros") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.83,
    width: 19.71,
    height: 38.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.65,
    y: 2.88,
    width: 14.08,
    height: 32.53
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "21.65 2.88 35.73 2.88 35.73 35.41"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 28.66,
    cy: 18.58,
    r: 8.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28.66,9.57a9,9,0,0,1,0,18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.91,19.27h-2A5.58,5.58,0,0,1,34,22.34l-1.38-.5A5.28,5.28,0,0,0,33.54,19c0-1.44-.82-2.38-2-2.38s-1.81.81-2.37,2.25c-.82,2.07-1.76,3.32-3.51,3.32a3.31,3.31,0,0,1-3.25-3.07h-2V17.83h1.94A6.13,6.13,0,0,1,23,15.2l1.32.5a4.91,4.91,0,0,0-.69,2.57c0,1.56.94,2.13,1.75,2.13,1.07,0,1.57-.75,2.32-2.51.87-2.06,1.87-3.12,3.69-3.12A3.58,3.58,0,0,1,34.85,18h2.06v1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28.59,16.27V20a11.63,11.63,0,0,0,.57-1.25c.62-1.5,1.31-2.25,2.37-2.25a2.13,2.13,0,0,1,2,2.37,5.07,5.07,0,0,1-.88,2.88l1.38.5a5.7,5.7,0,0,0,.87-3.06h2V18H34.85a3.43,3.43,0,0,0-6.26-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22.84,33.1V31H19.4A31.1,31.1,0,0,0,11.51,30,31.16,31.16,0,0,0,3.57,31H.06V33.1c0,.06-.06.12-.06.25,0,1.81,5.13,3.25,11.39,3.25s11.38-1.44,11.38-3.25A.44.44,0,0,0,22.84,33.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 11.45,
    cy: 31.28,
    rx: 11.39,
    ry: 3.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M11.45,28c6.32,0,11.39,1.44,11.39,3.25s-5.13,3.26-11.39,3.26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 11.45,
    cy: 30.72,
    rx: 7.26,
    ry: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M11.45,32.66c-4,0-7.26-.88-7.26-1.94s3.26-1.94,7.26-1.94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 8.01,
    cy: 30.04,
    rx: 2.44,
    ry: 0.5,
    transform: "translate(-3.62 1.21) rotate(-7.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M.81,32.47v2.07a5.85,5.85,0,0,0,.63.37V32.85A5.81,5.81,0,0,1,.81,32.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3.38,33.6v2.06a5.15,5.15,0,0,0,.62.19V33.79C3.82,33.72,3.57,33.66,3.38,33.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M6,34.16v2.07c.18,0,.37.06.62.06V34.22C6.38,34.22,6.19,34.16,6,34.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8.57,34.41v2.07a2.47,2.47,0,0,1,.63.06V34.47A2,2,0,0,1,8.57,34.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.45,34.54h-.31V36.6h.62V34.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13.7,34.47v2.07a2.47,2.47,0,0,0,.63-.06V34.41A2,2,0,0,1,13.7,34.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M16.33,34.22v2.07c.19,0,.44-.06.63-.06V34.16C16.71,34.16,16.52,34.22,16.33,34.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.89,33.72v2.07l.63-.19V33.54A1.45,1.45,0,0,1,18.89,33.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.46,32.85v2.06a5.85,5.85,0,0,0,.63-.37V32.47A5.81,5.81,0,0,1,21.46,32.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22.84,26.65V24.53H19.4a30.65,30.65,0,0,0-7.89-.94,30.23,30.23,0,0,0-7.88.94H.06v2.12c0,.07-.06.13-.06.25,0,1.82,5.13,3.26,11.39,3.26s11.38-1.44,11.38-3.26A.33.33,0,0,0,22.84,26.65Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 11.45,
    cy: 24.84,
    rx: 11.39,
    ry: 3.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M11.45,21.59c6.32,0,11.39,1.43,11.39,3.25s-5.13,3.25-11.39,3.25"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 11.45,
    cy: 24.28,
    rx: 7.26,
    ry: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M11.45,26.22c-4,0-7.26-.88-7.26-1.94s3.26-1.94,7.26-1.94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 8.01,
    cy: 23.59,
    rx: 2.44,
    ry: 0.5,
    transform: "translate(-2.83 1.16) rotate(-7.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M.81,26v2.06a5.81,5.81,0,0,0,.63.38V26.4A5.85,5.85,0,0,1,.81,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3.38,27.15v2.07l.62.19V27.34C3.82,27.28,3.57,27.22,3.38,27.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M6,27.72v2.06c.18,0,.37.06.62.06V27.78C6.38,27.78,6.19,27.72,6,27.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8.57,28V30a2.47,2.47,0,0,1,.63.06V28A2,2,0,0,1,8.57,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.45,28.09h-.31v2.07h.62V28.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13.7,28v2.06a2.47,2.47,0,0,0,.63-.06V28A2,2,0,0,1,13.7,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M16.33,27.78v2.06c.19,0,.44-.06.63-.06V27.72C16.71,27.72,16.52,27.78,16.33,27.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.89,27.34v2.07c.19-.07.44-.13.63-.19V27.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.46,26.4v2.07a5.81,5.81,0,0,0,.63-.38V26A5.85,5.85,0,0,1,21.46,26.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22.84,20.21V18.08H19.4a31.1,31.1,0,0,0-7.89-.94,30.66,30.66,0,0,0-7.88.94H.06v2.13c0,.06-.06.12-.06.25,0,1.81,5.13,3.25,11.39,3.25s11.38-1.44,11.38-3.25A.35.35,0,0,0,22.84,20.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 11.45,
    cy: 18.39,
    rx: 11.39,
    ry: 3.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M11.45,15.14c6.32,0,11.39,1.44,11.39,3.25s-5.13,3.26-11.39,3.26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 11.45,
    cy: 17.83,
    rx: 7.26,
    ry: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M11.45,19.77c-4,0-7.26-.88-7.26-1.94s3.26-1.94,7.26-1.94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 8.01,
    cy: 17.21,
    rx: 2.44,
    ry: 0.5,
    transform: "translate(-2.05 1.11) rotate(-7.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M.81,19.58v2.07a5.85,5.85,0,0,0,.63.37V20A5.81,5.81,0,0,1,.81,19.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3.38,20.71v2.06A5.15,5.15,0,0,0,4,23V20.9C3.82,20.83,3.57,20.77,3.38,20.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M6,21.27v2.07c.18,0,.37.06.62.06V21.34C6.38,21.34,6.19,21.27,6,21.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8.57,21.59v2.06a2.47,2.47,0,0,1,.63.06V21.65A2.47,2.47,0,0,0,8.57,21.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.45,21.65h-.31v2.06h.62V21.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13.7,21.59v2.06a2.47,2.47,0,0,0,.63-.06V21.52A1.77,1.77,0,0,1,13.7,21.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M16.33,21.34V23.4c.19,0,.44-.06.63-.06V21.27C16.71,21.27,16.52,21.34,16.33,21.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.89,20.9v2l.63-.19V20.65A6.25,6.25,0,0,1,18.89,20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.46,20V22a5.85,5.85,0,0,0,.63-.37V19.58A5.81,5.81,0,0,1,21.46,20Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagoEnEfectivo);
export default __webpack_public_path__ + "static/media/pago-en-efectivo.7216807989cd5bc545e2004929936776.svg";
export { ForwardRef as ReactComponent };